export enum NewBuilding {
    UNKNOWN = 0,
    NEW = 1,
    SECOND = 2,
}
